const getConfirmAssignmentValidation = (projectStartDate?: string) => ({
  fromDate: {
    type: 'date',
    required: true,
    minDate: {
      value: projectStartDate,
      message: 'Assignment start date cannot be earlier than project start date.',
    },
  },
  toDate: {
    type: 'date',
    required: true,
  },
  minPercent: {
    type: 'number',
    required: true,
  },
  maxPercent: {
    type: 'number',
    required: true,
  },
});

export default getConfirmAssignmentValidation;
